import { type ReactElement } from 'react';
import classNames from 'classnames';
import { type HemerotecaSearchValues } from '../HemerotecaSearchForm/config';
import { HemerotecaSearchForm } from '../HemerotecaSearchForm';

type HemerotecaHeroProps = {
	readonly className?: string;
	readonly onSearch: (payload: HemerotecaSearchValues) => void;
};

const classNameComponent = 'c-cnm-hemeroteca-hero';

export const HemerotecaHero = ({ className, onSearch }: HemerotecaHeroProps): ReactElement => {
	const wrapperClassName = classNames(classNameComponent, className);

	return (
		<section className={wrapperClassName}>
			{/* Imagen */}
			<div className={`${classNameComponent}__top`}>
				<img src="/colegio-madrid/images/academia-tomos.png" className={`${classNameComponent}__image`} />
			</div>

			{/* Buscador */}
			<div className={`${classNameComponent}__bottom`}>
				<HemerotecaSearchForm onSubmitSuccess={onSearch} />
			</div>
		</section>
	);
};
